
// Base.
import { Prop, Mixins } from 'vue-property-decorator'
import Component from 'vue-class-component'
import usersMixins from './UsersMixin'
import BlueButton from '../../components/Atomic/BlueButton.vue'
import CardTitle from '../../components/Atomic/CardTitle.vue'
// Used Models.
import { User } from '../../models/user'

@Component({
  components: {
    BlueButton,
    CardTitle,
  },
})
export default class CsvExport extends Mixins(usersMixins) {
  // Used for CSV Export.
  private jsonMeta: any = [{ key: 'charset', value: 'utf-8' }]
  private jsonFields: any = {}

  @Prop() private readonly jsonData!: User[]

  constructor() {
    super()
  }

  public mounted() {
    this.initialize()
  }

  private initialize() {
    this.setCsvExportConfig()
  }

  /* tslint:disable:no-string-literal */
  private setCsvExportConfig() {
    this.jsonFields['identifiant'] = 'identifiant'
    this.jsonFields['nom'] = 'nom'
    this.jsonFields['prenom'] = 'prenom'
    this.jsonFields['courriel'] = 'courriel'
    this.jsonFields['qualites'] = 'qualites'
    this.jsonFields['date_validite'] = 'date_validite'
    this.jsonFields[this.$t('USER.Password').toString()] = 'password'
  }
}
